export let environment = {
  production      : false,
  catalogs        : {
    dab:                              'https://dn1usv5uvaakn.cloudfront.net/api/catalog/dab',
    ic_acdc_catalogs:                 'https://dn1usv5uvaakn.cloudfront.net/api/catalog/acdc',
    ic_acdc_catalogs_chargers:        'https://dn1usv5uvaakn.cloudfront.net/api/catalog/charger',
    ic_dcdc_catalogs:                 'https://dn1usv5uvaakn.cloudfront.net/api/catalog/dcdc',
    ic_digital_power:                 '',
    ic_led_acdc_catalogs:             'https://dn1usv5uvaakn.cloudfront.net/api/catalog/acled',
    ic_led_catalogs:                  'https://dn1usv5uvaakn.cloudfront.net/api/catalog/led',
    llc:                              'https://dn1usv5uvaakn.cloudfront.net/api/catalog/llc',
    pfc:                              'https://dn1usv5uvaakn.cloudfront.net/api/catalog/pfc',
    pfcitp:                           'https://dn1usv5uvaakn.cloudfront.net/api/catalog/pfcitp',
    pfcitpccm:                        'https://dn1usv5uvaakn.cloudfront.net/api/catalog/pfc-itp-ccm',
    viennabidir:                      'https://dn1usv5uvaakn.cloudfront.net/api/catalog/vienna-bidir',
    vienna:                           'https://dn1usv5uvaakn.cloudfront.net/api/catalog/vienna',
    cllc:                             'https://dn1usv5uvaakn.cloudfront.net/api/catalog/cllc',
  },
  services        : {
    ic_translation_descriptions_srv:  '/bin/st/products/data.json'
  }
};
